import type {PropsWithChildren} from 'react'

type Props = PropsWithChildren & {
  disabled: boolean
}

export const DisabledWrapper = ({children, disabled}: Props) => {
  return (
    <div
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
      }}
    >
      <div
        style={{
          opacity: disabled ? 0.5 : undefined,
          pointerEvents: disabled ? 'none' : undefined,
        }}
      >
        {children}
      </div>
    </div>
  )
}
